export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1'

export const DATE_FORMATS = {
  display: 'MMM d, yyyy',
  displayWithTime: 'MMM d, yyyy h:mm a',
  input: 'yyyy-MM-dd',
  api: "yyyy-MM-dd'T'HH:mm:ss'Z'",
} as const

export const PAGINATION = {
  defaultPageSize: 20,
  maxPageSize: 100,
} as const

export const STALE_TIMES = {
  user: 5 * 60 * 1000, // 5 minutes
  families: 5 * 60 * 1000,
  health: 1 * 60 * 1000, // 1 minute
  financial: 5 * 60 * 1000,
  alerts: 30 * 1000, // 30 seconds
} as const

export const ALERT_SEVERITY_COLORS = {
  LOW: 'bg-gray-100 text-gray-800',
  MEDIUM: 'bg-warning-50 text-warning-700',
  HIGH: 'bg-error-50 text-error-700',
  CRITICAL: 'bg-error-600 text-white',
} as const

export const METRIC_UNITS = {
  STEPS: 'steps',
  HEART_RATE: 'bpm',
  HEART_RATE_RESTING: 'bpm',
  SLEEP_DURATION: 'hours',
  SLEEP_QUALITY: '%',
  BLOOD_PRESSURE_SYSTOLIC: 'mmHg',
  BLOOD_PRESSURE_DIASTOLIC: 'mmHg',
  WEIGHT: 'kg',
  FALL_DETECTED: '',
} as const
